import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 暴露出我们的接口请求,export导出
export function queryTeacherList(data) {
    return http.request({
        url: common.url + '/papi/teacher/list',
        method: 'get',
        params: data
    })
}
//获取根据id
export function queryTeacherById(id) {
    return http.request({
        url: common.url + '/papi/teacher/'+id,
        method: 'get'
    })
}
